// colli-ubersicht.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColliUbersichtComponent } from './colli-ubersicht.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AgGridModule } from 'ag-grid-angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [ColliUbersichtComponent],
  imports: [CommonModule,
            CollapseModule,
            AgGridModule,
            FontAwesomeModule],
  exports: [ColliUbersichtComponent]
})
export class ColliUbersichtModule { }

